import { Component, Input, OnChanges, OnInit, ViewChild} from '@angular/core';
import { DdcMatDialogService } from '../service/ddc-mat-dialog.service';
import { MAX_FILE_SIZE_ACCEPTED } from '../constant/constant';
import { SnackBarService } from '../service/snackbar.service';
import { DdcFileService } from '../service/ddc-file.service';
import { filterOkMapBody } from '../util/http.utils';
import { DdcFichier, IDdcFichier } from '../model/camp-fichier.model';
import { HttpResponse } from '@angular/common/http';

@Component({
    selector: 'ddc-piece-jointe',
    templateUrl: './piece-jointe.component.html',
    styleUrls: [],
    standalone: false
})
export class PieceJointeComponent implements OnInit, OnChanges {

  @ViewChild('matFileUpload') matFileUpload;

  @Input() set idDdc(idDdc: number) {
    this._idDdc = idDdc;
  }

  @Input() set typeDdc(typeDdc: string) {
    this._typeDdc = typeDdc;
  }

  @Input() set categorie(categorie: string) {
    this._categorie = categorie;
  }

  @Input() set subCategorie(subCategorie: string) {
    this._subCategorie = subCategorie;
  }

  @Input() set idSiteContexteMarin(idSiteContexteMarin: string) {
    this._idSiteContexteMarin = idSiteContexteMarin;
  }
  @Input() set sideBar(sideBar: boolean) {
    this._sideBar = sideBar;
  }

  ddcFichiers: DdcFichier[] = [];
  _idDdc: number;
  _typeDdc: string;
  _categorie: string;
  _subCategorie: string;
  _sideBar: boolean = false;
  _idSiteContexteMarin;

  initiated: boolean = false;

  constructor(
    protected ddcMatDialogService: DdcMatDialogService,
    protected snackBarService: SnackBarService,
    protected ddcFileService: DdcFileService,
  ) {
  }

  ngOnInit() {
      if(this._idDdc && this._typeDdc) {
        this.ddcFileService.getFilesByDdcIdAndDdcTypeAndCategorie(this._idDdc, this._typeDdc, this._categorie, this._subCategorie, parseInt(this._idSiteContexteMarin))
          .pipe(filterOkMapBody)
          .subscribe((ddcFichiers: IDdcFichier[]) => {
            this.ddcFichiers = ddcFichiers;
            this.initiated = true;
          });
      }
  }

  ngOnChanges() {
      this.ngOnInit()
  }

  addSelectedFiles() {
    if (this.matFileUpload.value && this.matFileUpload.value._files && this.matFileUpload.value._files.length > 0) {
      const chosenFile: File = this.matFileUpload['value']._files[0];
      if (chosenFile.size > MAX_FILE_SIZE_ACCEPTED) {
        this.snackBarService.showError('Ce fichier ne peut pas être téléchargé car il dépasse la taille acceptée ('+ MAX_FILE_SIZE_ACCEPTED/1000000 + 'Mb).');
      } else {
        this.uploadSelectedFile(chosenFile);
      }
    }
  }

  openDialogopenDialogSuppressionAttachment(id: number) {
    this.ddcMatDialogService.openConfirmActionDialog({
      content: 'Voulez-vous supprimer le fichier sélectionné ?',
      confirmText: 'Confirmer',
      cancelText: 'Annuler',
      confirmAction: () => this.deleteSelectedFile(id)
    });
  }

  uploadSelectedFile(selectedFile: File) {
    const formData = new FormData();
    formData.set('file', selectedFile);
    formData.set('idDdc', this._idDdc.toString());
    formData.set('typeDdc', this._typeDdc);
    formData.set('categorie', this._categorie);
    if(this._subCategorie) {
      formData.set('subCategorie', this._subCategorie);
    }
    if(this._idSiteContexteMarin) {
      formData.set('idSiteContexteMarin', this._idSiteContexteMarin);

    }
    this.ddcFileService.upload(formData)
      .subscribe((res: HttpResponse<IDdcFichier>) => {
        this.ddcFichiers.push(res.body);
        this.matFileUpload.clear();
      });
  }

  deleteSelectedFile(id: number) {
    this.ddcFileService.deleteFileByIdAndDdcType(id, this._typeDdc)
      .subscribe(res => {
        const ddcFichier: IDdcFichier = res.body;
        if(ddcFichier && ddcFichier.id) {
          const index = this.ddcFichiers.findIndex(fichier => fichier.id === ddcFichier.id);
          if(index !== -1) {
            this.ddcFichiers.splice(index, 1);
          }
        }
      })
  }

  downloadSelectedFile(id: number, fileName: string) {
    this.ddcFileService.downloadFileByIdAndDdcType(id, this._typeDdc)
      .subscribe((blob: Blob) => {
        if (window.navigator.msSaveOrOpenBlob) {
          // IE & Edge
          window.navigator.msSaveBlob(blob, fileName);
        } else {
          const tempLink = document.createElement('a');
          tempLink.href = window.URL.createObjectURL(blob);
          tempLink.download = fileName;
          document.body.appendChild(tempLink);
          tempLink.target = '_blank';
          tempLink.click();
          document.body.removeChild(tempLink);
        }
      });
    }

}
